import React from 'react';

interface ExportMenuItemProps {
  type: string;
  onExport: (type: string) => void;
  id?: string;
  'data-testid'?: string;
}

/**
 * ExportMenuItem component for individual export type options
 * @component
 * @param {Object} props - Component props
 * @param {string} props.type - Export type (csv, xlsx)
 * @param {Function} props.onExport - Callback function when export is triggered
 * @param {string} [props.id] - Optional ID for the button element
 * @param {string} [props.data-testid] - Optional test ID for testing
 * @returns {React.ReactElement} ExportMenuItem component
 */
const ExportMenuItem: React.FC<ExportMenuItemProps> = ({
  type,
  onExport,
  id,
  'data-testid': dataTestId,
}) => {
  // Map of export types to display names
  const titleMap: Record<string, string> = {
    csv: 'Export as CSV',
    xlsx: 'Export as Excel',
  };

  const handleClick = () => {
    onExport(type);
  };

  return (
    <button
      id={id}
      data-testid={dataTestId}
      className="w-full block text-left px-3 py-2 text-sm font-medium text-neutral-700 hover:bg-neutral-50 focus:outline-none focus:bg-neutral-50 rounded-md transition-colors duration-150"
      onClick={handleClick}
      type="button"
    >
      <span>{titleMap[type] || `Export as ${type.toUpperCase()}`}</span>
    </button>
  );
};

export default ExportMenuItem;
